import { ChangeEvent } from 'react';

export const onChangeVinCriterion = (
  vinCriteria: string[],
  setFieldValue: (
    field: string,
    value: string[],
    shouldValidate?: boolean | undefined
  ) => void
): ((index: number) => (event: ChangeEvent<HTMLInputElement>) => void) => {
  return (index: number) =>
    (event: ChangeEvent<HTMLInputElement>): void => {
      const updatedVinCriteria = [...vinCriteria];
      updatedVinCriteria[index] = event.target.value;
      setFieldValue('vinCriteria', updatedVinCriteria);
    };
};
